export default __webpack_public_path__ + "static/media/userAttributes.7f5afa98.png";